// extracted by mini-css-extract-plugin
export default {"l_ListCardHeaderText_main":"ListCardHeaderText_l_ListCardHeaderText_main__RGZj6"};